import * as React from "react";
import {Link, withRouter} from "react-router-dom";
import {RouteComponentProps} from "react-router-dom";
import "react-dates/lib/css/_datepicker.css";
import "./styles/hotels.less";

const Stepper: React.SFC<RouteComponentProps<any>> = (props: RouteComponentProps<any>) => {
    let step = 0;
    if (props.location.pathname.indexOf("summary") > -1) {
        step = 1;
    }
    const steps = [
        ["Choose your tickets", "/tickets"],
        ["Review your order", "/summary"],
    ];

    return (
        <ul className="nav nav-pills nav-stacked stepper">
            {steps.map((pair, index) => {
                const [txt, link] = pair;
                const selectedClass = index === step ? "active" : "";
                return (
                    <li className={selectedClass} key={index}>
                        <Link to={link}><label>Step {index + 1}</label> {txt}</Link>
                    </li>);
            })}
        </ul>
    );
};

export const RoutedStepper = withRouter<any>(Stepper);



// WEBPACK FOOTER //
// ./src/components/Stepper.tsx